import { styled } from '@mui/material/styles';

export const Container = styled('div')({
  padding: 15,
});

export const Tabs = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
});

export const Tab = styled('div')(({ theme }) => ({
  padding: '5px 5px 5px',
  margin: '0 5px',
  fontFamily: 'AvenirNext-DemiBold',
  fontSize: 12,
  fontWeight: 600,
  textAlign: 'center',
  color: theme.palette.text.primary,
  cursor: 'pointer',
  borderBottom: '3px solid transparent',
  '&.active': {
    borderBottom: `3px solid ${theme.palette.primary.main}`,
  },
}));

export const Content = styled('div')({
  padding: 7.5,
});

export const Box = styled('div')(({ theme }) => ({
  padding: 15,
  margin: 7.5,
  borderRadius: 5,
  border: `solid 1px ${theme.palette.divider}`,
  backgroundColor: theme.palette.common.white,
  boxSizing: 'border-box',
  height: 'calc(100% - 15px)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const BoxClient = styled(Box)({
  flexDirection: 'row',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
});

export const Text = styled('div')(({ theme }) => ({
  fontFamily: 'AvenirNext',
  fontSize: 12,
  fontWeight: 600,
  color: theme.palette.grey[400],
  textAlign: 'center',
}));

export const Text1 = styled(Text)({
  textAlign: 'left',
});

export const Text2 = styled(Text)(({ theme }) => ({
  fontFamily: 'AvenirNext-DemiBold',
  fontSize: 25,
  color: theme.palette.text.primary,
}));

export const Text3 = styled(Text)(({ theme }) => ({
  fontFamily: 'AvenirNext-DemiBold',
  fontSize: 18,
  color: theme.palette.text.primary,
}));

export const Label = styled(Text)(({ theme }) => ({
  fontFamily: 'AvenirNext-DemiBold',
  color: theme.palette.grey[400],
  textTransform: 'uppercase',
  marginBottom: 10,
}));

export const LabelClient = styled(Label)({
  margin: '0 15px 0 0',
});

export const ClientList = styled('div')({
  flex: 1,
  display: 'flex',
});

export const ClientLogo = styled('img')({
  margin: '0 5px',
});

export default {
  colShipmentInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  col: {
    flex: 1,
    height: '100%',
  },
  row: {
    flex: 1,
  },
};
